<template>
  <div class="row mx-3 justify-content-start">
    <span class="form-label align-self-start size-12 p-0">業種</span>
    <div class="w-100 p-0 d-flex gap-0 flex-wrap">
      <div
        v-for="(industry, idx) in props.industries.flatMap((category) =>
          category.children?.map((children) => ({ categoryName: category.name, children }))
        )"
        :key="industry?.children.id"
        class="mb-2 me-2 d-flex align-items-center col-auto p-0 mw-100"
      >
        <Field :id="`candidate_resume_industry_${idx}`" :name="`candidate_resume_industry[${idx}]`">
          <div class="align-items-center col-auto d-flex flex-nowrap w-100">
            <p
              class="col-auto bg-silver-primary px-3 py-1 mb-0 border border-fourth rounded-2 me-1 text-truncate flex-shrink-1"
            >
              {{ industry?.children.name }}
            </p>
            <img
              src="@/assets/image/icon-close-delete.svg"
              role="button"
              class="border rounded-circle border-third p-0d25"
              @click="onRemoveIndusty(industry?.children.id)"
            />
          </div>
        </Field>
      </div>
      <div class="d-flex justify-content-center w-100 mt-2">
        <AddButton class="mw-184x" title="業種を追加する" @click="addIndustry" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Field } from 'vee-validate';
import AddButton from '@/components/common/Button/AddButton/index.vue';

const onRemoveIndusty = (id: number) => {
  emit('remove', id);
};

const addIndustry = () => {
  emit('open');
};

const props = defineProps({
  industries: {
    type: Array as unknown as () => any,
    required: false,
  },
});

const emit = defineEmits(['open', 'remove']);
</script>
